import * as React from 'react';
import { VendorSearchViewModel } from '@models/Vendor';
import { Link } from 'react-router-dom';
import { getRoute, RouteDefinitions } from '@common/route-definitions';
import ReactTable, { Column } from 'react-table';

export interface VendorDuplicateReviewComponentProperties {
  readonly vendorSearchResults: VendorSearchViewModel[];
  readonly vendorSearchPageCount: number;
  readonly vendorName: string;
}

export interface VendorDuplicateReviewComponentState {
  duplicates: VendorSearchViewModel[];
}

export class VendorDuplicateReviewComponent extends React.Component<
  VendorDuplicateReviewComponentProperties,
  VendorDuplicateReviewComponentState
> {
  constructor(props: VendorDuplicateReviewComponentProperties) {
    super(props);
    this.state = {
      duplicates: this.props.vendorSearchResults.filter(
        v => v.name.toLowerCase() === this.props.vendorName.toLowerCase()
      )
    };
  }

  render() {
    const columns: Column[] = [
      {
        accessor: 'name',
        Header: 'Company Name',
        sortable: false,
        minWidth: 200
      },
      {
        accessor: 'address.line1',
        Header: 'Address',
        sortable: false,
        minWidth: 175
      },
      {
        accessor: (row: VendorSearchViewModel) => (
          <Link
            to={getRoute(RouteDefinitions.vendor.Details, {
              id: row.id
            })}
            target="_blank"
          >
            {'View Details'}
          </Link>
        ),
        id: 'id',
        Header: 'Link',
        sortable: false,
        width: 120
      }
    ];
    return (
      <div>
        <ReactTable
          onPageChange={() => {
            Array.from(document.getElementsByClassName('rt-tbody')).forEach(element => {
              element.scrollTop = 0;
            });
          }}
          className="-striped -highlight"
          columns={columns}
          data={this.state.duplicates} // id == 1 is "Call Own Sub"
          defaultPageSize={50}
          manual={true}
          pages={this.props.vendorSearchPageCount}
          previousText="Prev"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/vendor/_components/flows/steps/general-info/vendor-duplicate-review.component.tsx